module.exports = "/next-static/_next/static/images/hero_image_small-366ccbe575680e92820d10b012d97775.png";